import { ReactComponent as JobsRecommended } from "../../../assets/img/jobs-recommended.svg";
import { ReactComponent as JobsDraft } from "../../../assets/img/note_stack.svg";
import { ReactComponent as JobsSubmitted } from "../../../assets/img/list-check.svg";
import { ReactComponent as JobsArchived } from "../../../assets/img/jobs_archive.svg";

export const STEPS = {
  active: 'Active Applications',
  recommended: 'Recommended Jobs',
  submitted: 'Submitted Applications',
}

export const STEPS_DESCRIPTION = {
  active: 'This section shows your current jobs, and you can follow any suggested actions to move forward.',
  recommended: 'Explore remote jobs tailored to your skills. Based on your profile, preferences, and experience, we have curated a list of roles with top global companies.',
  submitted: 'This section displays all your submitted job applications.',
}

export const STEPS_EMPTY_TEXT = {
  active: 'No applications in progress, please check out recommended jobs.',
  recommended: 'No recommended jobs to show based on your experience',
  submitted: 'No applications submitted, please check out recommended jobs.',
}

export const STEPS_EMPTY_TEXT_V2 = {
  active: 'You have no applications in draft',
  recommended: 'No recommended jobs to show based on your experience',
  submitted: 'You have not submitted any applications yet.',
  archived: 'You do not have any archived applications yet.',
}

export const STEPS_V2 = {
  recommended: 'Jobs For You',
  active: 'Draft Applications',
  submitted: 'Submitted Applications',
  archived: 'Archived Applications',
}

export const STEPS_V2_DESCRIPTION = {
  recommended: 'Explore remote opportunities tailored to your skills. Based on your profile, preferences, and experience, we have curated a list of roles with top global companies. These opportunities are aligned with your career goals and expertise. Take the next step toward a job you will love.',
  active: 'These applications are still in progress and have not been submitted yet. To be considered for these roles, complete all the required steps, such as submitting the job interest form or passing the technical assessments. Once completed, your application will be eligible for review.',
  submitted: 'Track the progress of your submitted applications in one place. You can view each status directly on the job card and follow any updates as they happen, so you always know where you stand in the process.',
  archived: 'This is where your closed applications are stored for reference. Some roles may allow you to reapply after a certain period, check each status for more details.',
}

export const STEP_ICONS = {
  recommended: JobsRecommended,
  active: JobsDraft,
  submitted: JobsSubmitted,
  archived: JobsArchived,
}

export const APPLICATION_STATUS = {
    SUBMIT_ICF: 'submit_icf',
    TAKE_VETTING: 'take_vetting',
    COMPLETE_VETTING: 'complete_vetting',
    SUBMITTED: 'submitted',
    IN_REVIEW: 'in_review',
    REVIEW_COMPLETED: 'review_completed',
    SHORTLISTED: 'shortlisted',
    SELECTED: 'selected',
    SELECTED_FOR_ANOTHER_JOB: 'selected-for-another-job',
    ARCHIVED: 'archived',
};

export const APPLICATION_STATUS_TO_TEXT = {
  [APPLICATION_STATUS.SUBMITTED]: 'Pending Review',
  [APPLICATION_STATUS.IN_REVIEW]: 'In Review',
  [APPLICATION_STATUS.REVIEW_COMPLETED]: 'Review Completed',
  [APPLICATION_STATUS.SHORTLISTED]: 'Shortlisted',
  [APPLICATION_STATUS.SELECTED]: 'Selected',
  [APPLICATION_STATUS.SELECTED_FOR_ANOTHER_JOB]: 'Selected for Another Job',
  [APPLICATION_STATUS.ARCHIVED]: 'Archived',
}
